import { render, staticRenderFns } from "./ATextField.vue?vue&type=template&id=83c01c56"
import script from "./ATextField.vue?vue&type=script&lang=js"
export * from "./ATextField.vue?vue&type=script&lang=js"
import style0 from "./ATextField.vue?vue&type=style&index=0&id=83c01c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports